export const memberQueries = ["GroupMembers", "NotConfirmedGroupMembers"];

export const groupsQueries = ["GroupsInOrg", "GroupsForUser"];
